export default function telegram () {
  const ids = [329042132, 264252474, 349628294]
  // const ids = [329042132, 264252474]
  return ids
}
